import { IChangeReparcelingCardDTO } from 'modules/customer/domain/dtos';
import { ICustomerCardsRepository } from 'modules/customer/domain/repositories';
import { UseCaseError } from 'shared/domain/errors';
import { getCardFlagFrom } from 'shared/domain/helpers';

export class ChangeReparcelingCardUseCase {
  constructor(private customerCardsRepository: ICustomerCardsRepository) {}

  public async execute({ hash, card }: IChangeReparcelingCardDTO) {
    const flag = getCardFlagFrom(card.number);

    if (!flag) throw new UseCaseError('Unrecognized flag');

    return this.customerCardsRepository.update({
      process: 'REPARCELING',
      hash,
      card: {
        ...card,
        flag,
      },
    });
  }
}
